// Vue
// A progressive, incrementally-adoptable JavaScript framework for building UI on the web.
// https://github.com/vuejs/vue
import Vue from 'vue'

// Vue Router
// The official router for Vue.js.
// https://github.com/vuejs/vue-router
import VueRouter from 'vue-router'

// Define route components.
// These can be imported from other files
import Form from '@/views/form/Form'
import FormEdit from '@/views/form/FormEdit'
import FormReadOnly from '@/views/form/FormReadOnly'

import Wizard from '@/views/wizard/Wizard'

import PageLoading from '@/views/page/PageLoading.vue'
import PageNotFound from '@/views/page/PageNotFound.vue'
import Playground from '@/views/Playground/Playground'

// call
Vue.use(VueRouter)

// Define some routes
const routes = [
  {
    path: '/',
    component: PageLoading
  },
  {
    path: '/playground',
    component: Playground,
    children: [
      {
        path: 'form',
        name: 'form-playground',
        component: Form,
        props: true,
        children: [
          {
            path: 'edit',
            name: 'edit-playground',
            component: FormEdit,
            props: true
          },
          {
            path: 'read-only',
            name: 'read-only-playground',
            component: FormReadOnly,
            props: true
          }
        ]
      }
    ]
  },
  {
    path: '/form',
    name: 'form',
    component: Form,
    props: true,
    children: [
      {
        path: 'edit',
        name: 'edit',
        component: FormEdit,
        props: true
      },
      {
        path: 'read-only',
        name: 'read-only',
        component: FormReadOnly,
        props: true
      }
    ]
  },
  {
    path: '/wizard',
    name: 'wizard',
    component: Wizard,
    props: true
    // route level code-splitting
    // this generates a separate chunk (wizard.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "wizard" */ './views/Wizard.vue')
  },
  // Página não encontrada
  { path: '/404', component: PageNotFound },
  // Qualquer rota desconhecida, redireciona para 404
  { path: '*', redirect: '/404' }
]

// Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes // short for `routes: routes`
})

// // Global Navigation Guards
// // https://router.vuejs.org/guide/advanced/navigation-guards.html#global-guards
// router.beforeEach(async (to, from, next) => {
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     let token = store.getters['login/token']
//     if (!token) {
//       next({ path: '/404' })
//     } else {
//       next()
//     }
//   } else {
//     next()
//   }
// })

// Export instance vue-router
export default router
